/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'position',
})

export class PositionTypePipe implements PipeTransform {
  transform(key: string, value: string): string {
    if (key) {
      switch (key) {
      case 'PROCESSOR':
        value = 'Processor';
        break;
      case 'RESEARCH_ANALYST':
        value = 'Research Analyst';
        break;
      case 'FINANCIAL_ANALYST':
        value = 'Financial Analyst';
        break;
      case 'SENIOR_ANALYST':
        value = 'Senior Analyst';
        break;
      case 'SENIOR_APPRAISER':
        value = 'Senior Appraiser';
        break;
      case 'SENIOR_REVIEWER':
        value = 'Senior Reviewer';
        break;
      case 'OTHER':
        value = 'Other';
        break;
      }
    }
    return value;
  }
}
